import { AppMessageLevel, addMessage } from "@/features/app/appSlice";

import store from "@/app/store";

export interface FontData {
  download: boolean;
  fontName: string;
  url: string[];
}

export const FONT_BY_LANGUAGE: { [k: string]: FontData } = {
  ar: {
    download: false,
    fontName: "Janna LT",
    url: ["fonts/janna.woff2"],
  },
  bg: {
    download: false,
    fontName: "Montserrat Thin Regular",
    url: ["fonts/cyrillic.woff2", "fonts/cyrillic_ext.woff2"],
  },
  default: {
    download: false,
    fontName: "Lato",
    url: ["fonts/lato.woff2", "fonts/lato_ext.woff2"],
  },
  he: {
    download: false,
    fontName: "Heebo Regular",
    url: ["fonts/hebrew.woff2"],
  },
  ja: {
    download: false,
    fontName: "Noto Sans JP Thin Regular",
    url: ["fonts/japanese.woff2"],
  },
};
export const isValidFontFamilyName = (fontFamily: string): boolean => {
  const pattern = /^[a-zA-Z0-9\s\-_]+$/;
  return pattern.test(fontFamily);
};

export const isValidFontURL = (url?: string): boolean => {
  const pattern = /\.(ttf|otf|woff|woff2)$/i;
  return pattern.test(url);
};

export const loadFont = (fontFamily: string, url: string) => {
  if (!isValidFontURL(url)) {
    store.dispatch(
      addMessage({
        cancellable: true,
        id: "not_valid_font_url",
        level: AppMessageLevel.ERROR,
        message: "Not valid font url",
        persistent: false,
      }),
    );
    // console.error("Invalid font URL:", url);
    return;
  }
  const existingFont = Array.from(document.fonts).find(
    (font) => font.family === fontFamily,
  );
  if (existingFont) {
    // if already exists avoid overriding, others may be using it
    return;
  }

  try {
    const font = new FontFace(fontFamily, `url("${url}")`);
    // wait for font to be loaded
    font.load();
    // add font to document
    document.fonts.add(font);
  } catch (error) {
    console.error(`Error loading font`, { error, fontFamily });
  }
};

export const getFontNameFromURL = (url: string) => {
  const lastElement = url.split("/")?.pop() || "";

  if (lastElement.includes(".")) {
    return lastElement.substring(0, lastElement.lastIndexOf("."));
  }

  return lastElement;
};

export const getFontSourceFromURL = (url: string) => {
  const lastIndex = url.lastIndexOf("/");

  if (lastIndex === -1 || lastIndex === url.length - 1) {
    return url;
  }

  return `${url.substring(0, lastIndex)}/{fontstack}/{range}.pbf`;
};
